var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6889 5H18.3333C9.82222 5 5 9.82222 5 18.3333V41.6667C5 50.1778 9.82222 55 18.3333 55H41.6889C50.2 55 55 50.1778 55 41.6667V18.3333C55 9.82222 50.2 5 41.6889 5Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4221 23.4224C17.2888 23.4224 16.3555 24.3557 16.3555 25.5113V42.689C16.3555 43.8224 17.2888 44.7557 18.4221 44.7557C19.5777 44.7557 20.511 43.8224 20.511 42.689V25.5113C20.511 24.3557 19.5777 23.4224 18.4221 23.4224Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0901 15.2222C28.9568 15.2222 28.0234 16.1555 28.0234 17.3111V42.6888C28.0234 43.8222 28.9568 44.7555 30.0901 44.7555C31.2457 44.7555 32.179 43.8222 32.179 42.6888V17.3111C32.179 16.1555 31.2457 15.2222 30.0901 15.2222Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6006 32.4888C40.4451 32.4888 39.5117 33.4221 39.5117 34.5777V42.6888C39.5117 43.8221 40.4451 44.7554 41.5784 44.7554C42.7339 44.7554 43.6673 43.8221 43.6673 42.6888V34.5777C43.6673 33.4221 42.7339 32.4888 41.6006 32.4888Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEChart);
export default __webpack_public_path__ + "static/media/e-chart.6ccf060bd576b0ec4d405fd4d6aa7a2e.svg";
export { ForwardRef as ReactComponent };